/**
 * TrendUpIcon/index.js
 * desc: line chart trending up icon
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const TrendUpIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="trend-up icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.trendUp.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 12"><path d="M14 0l2.29 2.29-4.88 4.88-4-4L0 10.59 1.41 12l6-6 4 4 6.3-6.29L20 6V0h-6z"/></svg>
    </IconButton>
);


export default TrendUpIcon;
